// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__6gnOm","modal":"Modal_modal__TR2Gm","slide-down":"Modal_slide-down__03S66"};